import { AnimatePresence, motion } from 'motion/react'
import { type ResolvedBranchNode } from '@/lib/branchTypes'
import { PlaybookBranchNodeMarkdownContent } from '../PlaybookBranchNodeMarkdownContent'

type BranchChoiceMarkdownPreviewProps = {
  previewTargetId: string
  previewNode: ResolvedBranchNode
}

// Hover-only teaser of the markdown behind a branch before the user commits to that path.
const BranchChoiceMarkdownPreview = ({
  previewTargetId,
  previewNode,
}: BranchChoiceMarkdownPreviewProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="pointer-events-none"
    >
      <PlaybookBranchNodeMarkdownContent nodeId={previewTargetId} node={previewNode} fadeOut />
    </motion.div>
  )
}

type BranchChoicePreviewStackProps = {
  previewTargetId: string | null
  previewNode: ResolvedBranchNode | null
  branchPreviewHeightPx: number
}

// Fixed-height viewport so preview fade in/out doesn't collapse the surrounding playbook layout.
export const BranchChoicePreviewStack = ({
  previewTargetId,
  previewNode,
  branchPreviewHeightPx,
}: BranchChoicePreviewStackProps) => {
  return (
    <div className="overflow-hidden" style={{ height: branchPreviewHeightPx }}>
      <AnimatePresence initial={false}>
        {previewNode && previewTargetId && (
          <BranchChoiceMarkdownPreview
            key="branch-preview"
            previewTargetId={previewTargetId}
            previewNode={previewNode}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
